import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { metaCompraDimensaoLoteApi, type BuscarLoteFiltros } from '../api/metaCompraDimensaoLote';
import type { CriarMetaCompraDimensaoLoteRequest } from '../types/metaCompraDimensaoLote';

const KEY_LOTE = 'metaCompraDim-lote';
const STALE_LOTE = 2 * 60 * 1000;

export function useMetaCompraDimensaoLote(filtros: BuscarLoteFiltros, enabled = true) {
  return useQuery({
    queryKey: [KEY_LOTE, filtros],
    queryFn: () => metaCompraDimensaoLoteApi.buscar(filtros),
    enabled: enabled && filtros.empresas.length > 0 && !!filtros.anoMes && !!filtros.dimensao,
    staleTime: STALE_LOTE,
  });
}

/** Cria N metas de uma vez. Invalida lista principal + lote ao concluir. */
export function useCriarMetasCompraDimensaoLote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: CriarMetaCompraDimensaoLoteRequest) => metaCompraDimensaoLoteApi.criar(req),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['metaCompraDim-lista'] });
      qc.invalidateQueries({ queryKey: [KEY_LOTE] });
    },
  });
}
